import { differenceInMinutes } from 'date-fns';

import { type StudentScheduleSlot } from '../../model';
import { isCurrentTimeInRange, getSortedSchedule } from '../utils';

const TOTAL_CIRCLE_ANGLE = 360;
const TOTAL_SEMI_CIRCLE_ANGLE = TOTAL_CIRCLE_ANGLE / 2;

const TOTAL_CLOCK_INNER_TICKS = 120;
const ONE_TICK_ANGLE = TOTAL_CIRCLE_ANGLE / TOTAL_CLOCK_INNER_TICKS;
const TICK_START_ANGLE = 90;

/**
 * Calculates the angle of the hour hand on an analog clock.
 */
export const getHourHandAngle = (
  currentTime: Date,
  scheduleData: StudentScheduleSlot[]
): number => {
  const sortedScheduleData = getSortedSchedule(scheduleData);

  const eachSlotAngle = Math.round(TOTAL_SEMI_CIRCLE_ANGLE / sortedScheduleData.length);
  let hourAngle = 90;

  for (let i = 0; i < sortedScheduleData.length; i++) {
    const { startTime, endTime, angle: startAngle } = sortedScheduleData[i];

    if (!isCurrentTimeInRange(currentTime, startTime, endTime)) {
      continue;
    }

    const diffMinutes = differenceInMinutes(endTime, startTime);
    const eachMinuteAngle = eachSlotAngle / diffMinutes;
    const timeElapsed = differenceInMinutes(currentTime, startTime);
    hourAngle = startAngle + eachMinuteAngle * timeElapsed;
  }

  return hourAngle;
};

/**
 * Generates an array of inner ticks angles for an analog clock.
 */
export const generateClockInnerTickAngles = () => {
  const angles: number[] = [];

  for (let i = 1; i <= TOTAL_CLOCK_INNER_TICKS; i++) {
    const angle =
      (((i + TICK_START_ANGLE) % TOTAL_CIRCLE_ANGLE) * ONE_TICK_ANGLE) % TOTAL_CIRCLE_ANGLE;
    angles.push(angle);
  }

  return angles;
};
